<ng-container *ngIf="message; else outdated">
    <div class="countdown-container">
        <div class="countdown-body">
            <div class="countdown-right">
                <div class="countdown-content-days" *ngIf="message.days > 0" translate [translateParams]="{ count: message.days }">DAYS
                </div>
                <div class="countdown-content">
                    {{message.hours}}:{{message.minutes}}:{{message.seconds}}
                </div>
            </div>

        </div>
    </div>
</ng-container>
<ng-template #outdated>
    <div class="countdown-container">
        <span class="outdated-message">
            {{ 'COUNTDOWN_EXPIRATION_PREFIX' | translate}} {{parsedEndDate}}
        </span>
    </div>
</ng-template>